import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-mt-lg"
}
const _hoisted_2 = {
  key: 0,
  class: "text-negative"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_list_value_input = _resolveComponent("list-value-input")!
  const _component_local_date_picker = _resolveComponent("local-date-picker")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeInfoGroupFields, (field, index) => {
    return (_openBlock(), _createElementBlock("div", { key: index }, [
      (_ctx.isInfogroupFieldEnabled(field))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (field.valueType !== _ctx.FieldValueType.BOOLEAN)
              ? (_openBlock(), _createElementBlock("span", _normalizeProps(_mergeProps({ key: 0 }, _ctx.TEXT_FORM_FIELD_LABEL)), [
                  _createTextVNode(_toDisplayString(_ctx.getInfogroupFieldLabel(field)) + " ", 1),
                  (_ctx.mandatory)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.t('MANDATORY')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_icon, _mergeProps({
                    name: _ctx.ICONS_NAME.INFO_CIRCLE_SOLID,
                    color: "grey"
                  }, _ctx.ICON_PROPS.BTN_SM), {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.getInfogroupFieldDescription(field)), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.t('INITIAL_NAME', { label: field.defaultLabel })), 1)
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    _: 2
                  }, 1040, ["name"])
                ], 16))
              : _createCommentVNode("", true),
            _createElementVNode("div", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), [
              (field.valueType === _ctx.FieldValueType.LIST_VALUE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_list_value_input, {
                      "info-group-name": _ctx.infoGroup.attributeName,
                      "field-data": _ctx.getFieldData(field.attributeName),
                      field: field,
                      "info-group-type": _ctx.infoGroup.infogroupType,
                      "on@update": _ctx.updateListValue
                    }, null, 8, ["info-group-name", "field-data", "field", "info-group-type", "on@update"])
                  ]))
                : (field.valueType === _ctx.FieldValueType.DATE)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_local_date_picker, {
                        clearable: "",
                        modelValue: _ctx.updatedInfoGroup[field.attributeName],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.updatedInfoGroup[field.attributeName]) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.FieldValueTypeComponentMap.get(field.valueType)), _mergeProps({
                        placeholder: _ctx.t(`PLACEHOLDER.${field.valueType}`)
                      }, _ctx.FieldValueTypeDesignTokenMap.get(field.valueType), {
                        maxlength: _ctx.getInputMaxLength(field),
                        modelValue: _ctx.updatedInfoGroup[field.attributeName],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.updatedInfoGroup[field.attributeName]) = $event)
                      }), {
                        default: _withCtx(() => [
                          (field.valueType === _ctx.FieldValueType.BOOLEAN)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getInfogroupFieldLabel(field)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1040, ["placeholder", "maxlength", "modelValue", "onUpdate:modelValue"]))
                    ]))
            ], 16)
          ]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}